export default __webpack_public_path__ + "static/media/metamask_fox.47bfefbf.svg";